import React from 'react';
import { Box, Container, Typography, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const PrivacyPage = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 4 }}>
          <Link component={RouterLink} to="/" underline="hover" color="inherit">
            Inicio
          </Link>
          <Typography color="text.primary">Política de Privacidad</Typography>
        </Breadcrumbs>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
            Política de Privacidad
          </Typography>

          <Typography variant="body1" paragraph>
            Última actualización: {new Date().toLocaleDateString()}
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            1. Información que recopilamos
          </Typography>
          <Typography variant="body1" paragraph>
            MekaSys recopila información personal y de uso cuando usted utiliza nuestra plataforma. Esto incluye:
          </Typography>
          <ul>
            <Typography component="li" variant="body1">Datos de registro: nombre, correo electrónico, número de teléfono</Typography>
            <Typography component="li" variant="body1">Información de clientes y vehículos ingresada en el sistema</Typography>
            <Typography component="li" variant="body1">Datos de uso: cómo interactúa con nuestra plataforma</Typography>
            <Typography component="li" variant="body1">Información técnica: IP, navegador, dispositivo</Typography>
          </ul>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            2. Cómo utilizamos su información
          </Typography>
          <Typography variant="body1" paragraph>
            Utilizamos la información recopilada para:
          </Typography>
          <ul>
            <Typography component="li" variant="body1">Proporcionar y mantener nuestros servicios</Typography>
            <Typography component="li" variant="body1">Mejorar y personalizar su experiencia con la plataforma</Typography>
            <Typography component="li" variant="body1">Comunicarnos con usted sobre actualizaciones o cambios</Typography>
            <Typography component="li" variant="body1">Enviarle material de marketing y promocional</Typography>
            <Typography component="li" variant="body1">Analizar tendencias de uso para optimizar nuestros servicios</Typography>
          </ul>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            3. Marketing
          </Typography>
          <Typography variant="body1" paragraph>
            Podemos utilizar sus datos para enviarle información sobre productos y servicios que consideramos pueden ser de su interés. Al aceptar esta Política de Privacidad, usted consiente el uso de sus datos para fines de marketing directo. Puede optar por dejar de recibir estas comunicaciones en cualquier momento a través de la opción de cancelación de suscripción incluida en nuestros correos o poniéndose en contacto con nosotros.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            4. Compartir su información
          </Typography>
          <Typography variant="body1" paragraph>
            No compartimos su información personal con terceros excepto en las siguientes circunstancias:
          </Typography>
          <ul>
            <Typography component="li" variant="body1">Con proveedores de servicios que nos ayudan a operar nuestra plataforma</Typography>
            <Typography component="li" variant="body1">Cuando sea requerido por ley o para proteger nuestros derechos</Typography>
            <Typography component="li" variant="body1">En caso de una fusión, adquisición o venta de activos</Typography>
          </ul>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            5. Seguridad de los datos
          </Typography>
          <Typography variant="body1" paragraph>
            Implementamos medidas técnicas y organizativas apropiadas para proteger sus datos personales contra el acceso, uso o divulgación no autorizados. Sin embargo, ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            6. Sus derechos
          </Typography>
          <Typography variant="body1" paragraph>
            Usted tiene derecho a acceder, corregir, eliminar o limitar el procesamiento de sus datos personales. También puede solicitar la portabilidad de sus datos o retirar su consentimiento en cualquier momento.
          </Typography>

          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 600 }}>
            7. Cambios a esta política
          </Typography>
          <Typography variant="body1" paragraph>
            Podemos actualizar nuestra Política de Privacidad periódicamente. Le notificaremos cualquier cambio publicando la nueva Política de Privacidad en esta página.
          </Typography>

          <Typography variant="body1" paragraph sx={{ mt: 6 }}>
            Para cualquier consulta relacionada con nuestra política de privacidad, puede contactarnos a través de: contacto@mekasys.info
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default PrivacyPage; 